function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getEnvironmentName } from "core/utils/runtime-environment";
import OpenIdConnectService, { Issuer } from "./open-id-connect";
export default class ProSanteConnect extends OpenIdConnectService {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "label", "Pro Santé Connect");
    _defineProperty(this, "imageUrl", "/assets/ui-images/pro-sante-connect-logo.svg");
    _defineProperty(this, "issuer", "pro-sante-connect");
    _defineProperty(this, "route", "login.pro-sante-connect");
  }
  get isEnabled() {
    return this.isDevelopment;
  }
  get logoutUrl() {
    return `${this.logoutBaseUrl}?post_logout_redirect_uri=${this.logoutRedirectUri}`;
  }
  get baseUrl() {
    return window.location.origin;
  }
  get isDevelopment() {
    return ["local", "master"].includes(getEnvironmentName()) || this.baseUrl.includes("test");
  }
  get logoutRedirectUri() {
    return `${this.baseUrl}/medics-web/logout&id_token_hint=${this.idToken}`;
  }
  get idToken() {
    return this.session.data?.authenticated?.id_token;
  }
  get logoutBaseUrl() {
    return this.isDevelopment ? "https://auth.bas.psc.esante.gouv.fr/auth/realms/esante-wallet/protocol/openid-connect/logout" : "https://auth.esw.esante.gouv.fr/auth/realms/esante-wallet/protocol/openid-connect/logout";
  }
}